import type { Invariant } from '@rosetta/shared';
import { useId } from 'react';
import { MarqueInvariant } from './marque-invariant';

interface ListeInvariantsProps {
  /** The invariants of the analysis; an empty list is a step that found none. */
  invariants: readonly Invariant[];
}

const CELLULE = 'border-gray-100 border-t px-6';

/**
 * The invariants under the two texts (#9): the element, its type and its lock, marked as in the
 * texts (their key is above the texts, #30). An empty list says so rather than leaving a hole.
 */
export function ListeInvariants({ invariants }: ListeInvariantsProps) {
  const idTitre = useId();
  const vide = invariants.length === 0;
  return (
    <section aria-labelledby={idTitre} className="rounded-md border border-gray-200">
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 px-6 py-4">
        <h2 id={idTitre} className="font-bold text-body">
          Invariants
          {vide ? null : <span className="font-normal text-gray-600"> ({invariants.length})</span>}
        </h2>
      </div>
      {vide ? (
        <p className={`${CELLULE} py-4 text-body text-gray-700`}>Aucun invariant repéré</p>
      ) : (
        <table aria-labelledby={idTitre} className="w-full border-collapse text-body">
          <thead>
            <tr className="text-left text-caption text-gray-600">
              <th scope="col" className={`${CELLULE} py-2 font-semibold`}>
                élément
              </th>
              <th scope="col" className={`${CELLULE} py-2 font-semibold`}>
                type
              </th>
              <th scope="col" className={`${CELLULE} py-2 font-semibold`}>
                verrou
              </th>
            </tr>
          </thead>
          <tbody>
            {invariants.map((invariant) => (
              <tr key={`${invariant.verrou}|${invariant.valeur}`}>
                <th scope="row" className={`${CELLULE} py-3 text-left font-normal`}>
                  <MarqueInvariant verrou={invariant.verrou}>{invariant.valeur}</MarqueInvariant>
                </th>
                <td className={`${CELLULE} py-3 text-gray-700`}>{invariant.type}</td>
                <td className={`${CELLULE} py-3 text-gray-700`}>{invariant.verrou}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
